import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';
import { selectBestPerformingDashboard } from '@epicuro-next/state/analytics-entities';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DashboardGuard {
  constructor(private store: Store, private router: Router) {}

  public canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([
      atxIsMobile$,
      this.store.select(selectBestPerformingDashboard),
    ]).pipe(
      map(([isMobile, bestPerformingDashboard]) => {
        if (
          !isMobile &&
          (bestPerformingDashboard.dashboards?.lists?.enabled ||
            bestPerformingDashboard.dashboards?.articles?.enabled)
        ) {
          return true;
        }

        // on mobile or when none of the lists are enabled go back to product list
        return this.router.parseUrl(
          `/${APP_PRIVATE_PATHS.browse.path}/${APP_PRIVATE_PATHS.productList.path}`,
        );
      }),
    );
  }
}
